'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { PropsWithChildren, useState, ReactElement } from 'react';
import { RouterProvider } from 'react-aria-components';
import { AppointmentProvider } from '@provider-directory/contexts/AppointmentContext';

declare module 'react-aria-components' {
  interface RouterConfig {
    routerOptions: NonNullable<
      Parameters<ReturnType<typeof useRouter>['push']>[1]
    >;
  }
}

export function ClientProviders({ children }: PropsWithChildren): ReactElement {
  const router = useRouter();
  const [client] = useState(() => new QueryClient());

  return (
    <RouterProvider navigate={router.push}>
      <QueryClientProvider client={client}>
        <AppointmentProvider>{children}</AppointmentProvider>
      </QueryClientProvider>
    </RouterProvider>
  );
}
